var exports = {
  "SP": "commentIndicatorContainer__4O6ov4",
  "GE": "AvatarStack__qRZ1Mn",
  "at": "Compact__yQWbzl",
  "wL": "Relaxed__Q1iZ1W",
  "Ut": "textStyles__q6BQcy",
};

module.exports = exports;
